import { createSelector } from '@ngrx/store';
import { getRouterState } from '../store/store.selectors';

export const getActiveRoute = createSelector(
  getRouterState,
  (state: any) => state
);
